import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import ConsultationForm from './pages/ConsultationForm';
import AdminColumbarium from './pages/AdminColumbarium';
import ScrollToTop from './ScrollToTop';

import './App.css';


function Header() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(prev => !prev);
  };

  return (
    <header className="header">
      <div className="logo">
      <img 
          src="/logo192.png" 
          alt="Logo" 
          className="logo-image" 
        />
        <h1><Link to="/">아산 메모리얼 파크</Link></h1>
      </div>
      <nav className="nav">
        {/* 데스크탑 내비게이션 (모바일에서는 숨김) */}
        <ul className="nav-links">
          {/* <li>홈</li> */}
          <li><Link to="/about">공원소개</Link></li>
          <li><Link to="/services">분양안내</Link></li>
          <li><Link to="/contact">상담안내</Link></li>
        </ul>
        {/* 모바일 메뉴 버튼 (데스크탑에서는 숨김) */}
        <button className="mobile-menu-button" onClick={togglePopup}>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>
      </nav>
      {/* 모바일 팝업 메뉴 */}
      <div className={`popup-menu ${isPopupOpen ? 'open' : ''}`}>
        <div className="popup-content">
          <button className="popup-close" onClick={togglePopup}>×</button>
          <ul>
            <li><Link to="/" onClick={togglePopup}>홈</Link></li>
            <li><Link to="/about" onClick={togglePopup}>공원소개</Link></li>
            <li><Link to="/services" onClick={togglePopup}>분양안내</Link></li>
            <li><Link to="/contact" onClick={togglePopup}>상담안내</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
}


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* 왼쪽 영역 */}
        <div className="footer-right">
          <h3>아산 메모리얼 파크</h3>
          <p>아산메모리얼파크 임성(주)</p>
          <p>충남 아산시 송악면 외암로 55-15</p>
          <p style={{ color: '#665e5c', fontSize: '12px' }}>
            Copyright &copy; 2025 Asan Memorial Park.<br />
            All Rights Reserved.
          </p>
        </div>
        
        {/* 오른쪽 영역 */}
        <div className="footer-left">
          <p><strong>상담안내</strong> 1577-8788</p>
          <p><strong>영업시간</strong> 10:00 ~ 17:00 </p>
          <p><strong>휴무안내</strong> 영업일 연중무휴, 명절 당일 휴무</p>
        </div>
        
      </div>
    </footer>
  );
}



function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/columbarium" element={<AdminColumbarium />} />
        </Routes> 

        {!isAdminRoute && (
          <div className="bottom-wrapper">
            <ConsultationForm />
            <Footer />
          </div>
        )}
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;